@if (iframeUrl) {
  <iframe
    #iframe
    [src]="iframeUrl"
    style="width: 100%; height: 100%; border: none"
    title="Consent Form"
  ></iframe>
}
